import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import { IconTicket } from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export function SidebarSupportComponent() {
  const navigate = useNavigate();
  const theme = useTheme();
  const location = useLocation();
  const lgUp = useMediaQuery(themeSecound => themeSecound.breakpoints.up("lg"));
  const customizer = useSelector(state => state.customizer);
  const { role } = useSelector(state => state.reducer.userData);
  const hideMenu = lgUp ? customizer?.isCollapse && !customizer?.isSidebarHover : "";

  const onClickNavigate = () => {
    if (role === "SUPERADMIN" || role === "COORDINATOR") {
      return navigate("/tickets");
    }
    return navigate("/support");
  };
  const isActiveRoute = location.pathname === "/support" || location.pathname === "/tickets";
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      sx={{
        cursor: "pointer",
        m: 3,
        p: 2,
        backgroundColor: isActiveRoute ? theme.palette.primary.main : theme.palette.primary.main + "21",
        color: isActiveRoute || theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        borderRadius: "4px",
        "&:hover": {
          backgroundColor: theme.palette.primary.main,
          color: "#ffffff",
        },
        "&.ProfileAvatarWrapper": { p: 0, pt: 2, pb: 2, bgcolor: "transparent" },
      }}
      className={!hideMenu ? "" : "ProfileAvatarWrapper"}
      onClick={() => onClickNavigate()}
    >
      {!hideMenu ? (
        <>
          {" "}
          {role === "SUPERADMIN" || role === "COORDINATOR" ? <SupervisorAccountIcon /> : <IconTicket />}
          <Box sx={{ width: "110px", overflow: "hidden" }}>
            <Typography sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }} variant="h6">
              Support
            </Typography>
          </Box>
        </>
      ) : role === "SUPERADMIN" || role === "COORDINATOR" ? (
        <SupervisorAccountIcon />
      ) : (
        <IconTicket />
      )}
    </Box>
  );
}
